<template>
    <div class="container">
        <div class="col-xs-12 col-lg-4 col-lg-offset-4 custom-shadow">
            <div class="ph3 pv3">

                <div class="tc">
                    <h4 class="mh5">Sign up to finish posting your listing.</h4>

                    <div class="mt3">Already have an account?</div>
                    <a class="link black pointer" @click="$emit('signUpClick')"><h5 class="yellow mt1 mb3 grow">Log in Now</h5></a>
                </div>

                <signupCore/>

            </div>
        </div>
    </div>
</template>

<script>
import SignupCore from '@/components/global/SignupCore.vue';

export default {
    components: {
        SignupCore
    }
};
</script>
